import { Controller } from "@hotwired/stimulus"
import { observeVisibility } from "../lib/motion"

// Pauses CSS ambient loops (waveforms, marquees, pulses) while the section is off-screen.
// The matching CSS lives in application.tailwind.css under `.is-offscreen`.
export default class extends Controller {
  connect() {
    this.stop = observeVisibility(this.element, (visible) => {
      this.element.classList.toggle("is-offscreen", !visible)
    }, { rootMargin: "0px" })
  }

  disconnect() {
    this.stop?.()
    this.element.classList.remove("is-offscreen")
  }
}
